document.addEventListener('DOMContentLoaded', function () {
  var wrappers = document.querySelectorAll('.reels-showcase-wrapper');

  wrappers.forEach(function (wrapper) {
    var grid = wrapper.querySelector('.reels-grid');
    if (!grid) return;

    var prevBtn = wrapper.querySelector('.reels-arrow-btn--left');
    var nextBtn = wrapper.querySelector('.reels-arrow-btn--right');

    // Slider drag behavior
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    function startDrag(e) {
      // Only enable custom drag for mouse, let touch use native scrolling
      if (e.type === 'touchstart') return;
      isDown = true;
      grid.classList.add('is-dragging');
      startX = e.pageX - grid.offsetLeft;
      scrollLeft = grid.scrollLeft;
    }

    function endDrag() {
      isDown = false;
      grid.classList.remove('is-dragging');
    }

    function onMove(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - grid.offsetLeft;
      var walk = (x - startX) * 1.1; // drag speed
      grid.scrollLeft = scrollLeft - walk;
    }

    grid.addEventListener('mousedown', startDrag);

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('mouseleave', endDrag);

    grid.addEventListener('mousemove', onMove);

    // Arrow button scroll helpers
    function getSlideWidth() {
      var item = grid.querySelector('.reels-item');
      if (!item) return grid.clientWidth;
      var style = window.getComputedStyle(item);
      var marginRight = parseFloat(style.marginRight) || 0;
      return item.getBoundingClientRect().width + marginRight;
    }

    function updateArrowState() {
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      if (!prevBtn || !nextBtn) return;

      if (grid.scrollLeft <= 2) {
        prevBtn.classList.add('reels-hidden');
      } else {
        prevBtn.classList.remove('reels-hidden');
      }

      if (grid.scrollLeft >= maxScroll) {
        nextBtn.classList.add('reels-hidden');
      } else {
        nextBtn.classList.remove('reels-hidden');
      }
    }

    function scrollByDirection(dir) {
      var amount = getSlideWidth();
      grid.scrollTo({
        left: grid.scrollLeft + dir * amount,
        behavior: 'smooth'
      });
    }

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollByDirection(-1);
      });

      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        scrollByDirection(1);
      });

      grid.addEventListener('scroll', updateArrowState);
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }

    // Mute toggle for uploaded videos
    var items = grid.querySelectorAll('.reels-item');

    items.forEach(function (item) {
      var video = item.querySelector('video');
      var muteBtn = item.querySelector('.reels-mute-btn');
      if (!video || !muteBtn) return;

      // Force default muted
      video.muted = true;

      var iconOn = muteBtn.querySelector('.reels-mute-on');
      var iconOff = muteBtn.querySelector('.reels-mute-off');

      function updateIcons() {
        if (video.muted) {
          if (iconOn) iconOn.classList.add('reels-hidden');
          if (iconOff) iconOff.classList.remove('reels-hidden');
        } else {
          if (iconOn) iconOn.classList.remove('reels-hidden');
          if (iconOff) iconOff.classList.add('reels-hidden');
        }
      }

      // Initial state
      updateIcons();

      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        video.muted = !video.muted;
        updateIcons();
      });
    });
  });
});


